import React from "react";
import TitleUpdater from "../../components/common/title/TitleUpdater";
import { useTranslation } from "react-i18next";

const Notifications = () => {
  const { t } = useTranslation("translation");

  return (
    <div>
      <TitleUpdater title={t("notifications")} />
      {t("notifications")}
    </div>
  );
};

export default Notifications;
